import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonComponent } from '../../button/button.component';
import { AggregateType, AggregateTypeLabels } from '../../../models/aggregates/aggregate-type.enum';
import {
  AggregateInspectionStatus,
  AggregateInspectionStatusLabels,
} from '../../../models/status/aggregate-inspection-status.enum';

@Component({
  selector: 'app-aggregate-filter',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IconFieldModule,
    InputIconModule,
    MultiSelectModule,
    CalendarModule,
    ButtonComponent,
    InputTextModule,
  ],
  templateUrl: './aggregate-filter.component.html',
  styleUrls: ['./aggregate-filter.component.scss'],
})
export class AggregateFilterComponent {
  @Output() filtered = new EventEmitter<any>();

  statuses = Object.values(AggregateInspectionStatus).map((key) => ({
    label: AggregateInspectionStatusLabels[key],
    value: key,
  }));

  types = Object.values(AggregateType).map((key) => ({
    label: AggregateTypeLabels[key],
    value: key,
  }));

  filter: any = {
    idrId: '',
    name: '',
    location: '',
    customerId: '',
    type: [],
    status: [],
    inspectionDateRange: null,
  };

  filterAggregates() {
    this.filtered.emit(this.filter);
  }

  clearFilter() {
    this.filter = {
      idrId: '',
      name: '',
      location: '',
      customerId: '',
      type: [],
      status: [],
      inspectionDateRange: null,
    };
    this.filtered.emit(this.filter);
  }

  isInspectionRangeValid(): boolean {
    const range = this.filter.inspectionDateRange;
    if (!range || range.length === 0) return true;
    const [start, end] = range;
    return !!start && !!end;
  }
}
